import { ProductType, UrlParamKeyValuePair } from '../../../common';
import { getProduct } from '../../../product-catalogue';
import { SFCCProductPrice } from '../../models';
import { Price } from '../../models/price';
import { getPricingApiConfig } from '../pricing-api';
import { getPricesByIds } from './get-prices-by-ids';
import { getPricesBySkus } from './get-prices-by-skus';

export const getProductPrice = async (
  productId: number,
  queryParams?: UrlParamKeyValuePair[]
): Promise<Price | SFCCProductPrice | null> => {
  const { isSFCCPricingOn, marketLocale } = getPricingApiConfig();

  try {
    if (isSFCCPricingOn) {
      const product = await getProduct(productId, marketLocale);
      const productSku = product?.sku;

      if (productSku) {
        return await getPricesBySkus<SFCCProductPrice>([productSku], queryParams);
      }

      return null;
    } else {
      const prices = await getPricesByIds<Price[]>([productId], ProductType.Product);
      return prices?.[0] || null;
    }
  } catch (error) {
    console.error(`Error fetching price for product ID ${productId}:`, error);
    return null;
  }
};
